
import { Company } from "@/models/company";
import Vue from "vue";
import AppCompanyEditDefault from "./CompanyEditDefault.vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Company,
			required: true
		}
	},
	methods: {
		onInput(value:Company){
			this.$emit("input", value);
		}
	},
	components: {
		AppCompanyEditWrapper,
		AppCompanyEditDefault
	}
});
